/* eslint-disable */
export const debouncePromise = (f, interval) => {
  let timer = null;

  return (...args) => {
    clearTimeout(timer);
    return new Promise(resolve => {
      timer = setTimeout(() => resolve(f(...args)), interval);
    });
  };
};

export default function (func, wait, immediate) {
  let timeout;
  return function () {
    const context = this;

    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
